import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import * as homePage from "../../api/home-page";
import { APIError } from "../../api/api";

import Actions from "../actions";
import { HomePage } from "../../shared/home-page-models";

interface HomePageSuccess {
  type: Actions.HOME_PAGE_SUCCESS;
  payload: HomePage;
}
interface HomePageRequest {
  type: Actions.HOME_PAGE_REQUEST;
  payload: boolean;
}

interface HomePageFail {
  type: Actions.HOME_PAGE_FAIL;
  payload: string;
}

export type Action = HomePageFail | HomePageRequest | HomePageSuccess;

export const isSuccess = (currentUser: HomePage): HomePageSuccess => {
  return { type: Actions.HOME_PAGE_SUCCESS, payload: currentUser };
};
export const isRequest = (isFetching: boolean): HomePageRequest => {
  return { type: Actions.HOME_PAGE_REQUEST, payload: isFetching };
};
export const isFail = (error: string): HomePageFail => {
  return { type: Actions.HOME_PAGE_FAIL, payload: error };
};

export const getHomePageData = (): ThunkAction<
  Promise<void>,
  {},
  {},
  AnyAction
> => {
  return async (dispatch: ThunkDispatch<{}, {}, AnyAction>): Promise<void> => {
    dispatch(isRequest(true));
    try {
      const response = await homePage.getHomePageData();
      dispatch(isSuccess(response));
    } catch (e: any) {
      dispatch(
        isFail(
          e.response.data.errors.map((error: APIError) => error.title).join(" ")
        )
      );
    }
  };
};
